import { useContext } from "react";
import SocketContext from "@/common/context/SocketContext";

export default function useSocket() {
  return useContext(SocketContext);
}
